import type React from "react";
import { ReactComponent as Svg } from "./assets/arrow-down-1.svg";
import * as styles from "./Icon.module.scss";

type ChevronDownProps = React.SVGProps<SVGSVGElement>;

export const ChevronDown = ({ className, ...props }: ChevronDownProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
